import React from 'react';
import styles from '../styles/datatable.module.css';

const DataTable = ({
    title,
    columns,
    data,
    loading = false,
    pagination,
    onExport,
    headerExtra,
    onRowClick,
    getRowKey,
    compact = false,
}) => {
    return (
        <div className={`${styles.tableContainer} ${compact ? styles.tableContainerCompact : ''}`}>
            <div className={styles.tableHeader}>
                <h2 className={styles.title}>{title}</h2>
                {(headerExtra || onExport) && (
                    <div className={styles.tableHeaderActions}>
                        {headerExtra}
                        {onExport && (
                            <button className={styles.exportButton} onClick={onExport} title="Exportar a Excel">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Exportar
                            </button>
                        )}
                    </div>
                )}
            </div>

            <div className={styles.tableWrapper}>
                {loading ? (
                    <div className={styles.loadingState}>
                        <div className={styles.spinner}></div>
                        <span>Cargando datos...</span>
                    </div>
                ) : (
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                {columns.map((col, index) => (
                                    <th key={index} className={styles.th}>{col.header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((row, rowIndex) => {
                                    const rowKey = getRowKey ? getRowKey(row, rowIndex) : rowIndex;
                                    return (
                                    <tr
                                        key={rowKey}
                                        className={`${styles.tr} ${onRowClick ? styles.trClickable : ''}`}
                                        onClick={onRowClick ? () => onRowClick(row) : undefined}
                                    >
                                        {columns.map((col, colIndex) => (
                                            <td key={colIndex} className={styles.td}>
                                                {col.render ? col.render(row) : row[col.accessor]}
                                            </td>
                                        ))}
                                    </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={columns.length} className={styles.emptyState}>
                                        No hay datos disponibles
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            {pagination && !loading && data.length > 0 && (
                <div className={styles.pagination}>
                    <button
                        onClick={pagination.onPrev}
                        disabled={pagination.currentPage === 1}
                        className={styles.pageButton}
                    >
                        Anterior
                    </button>

                    <span className={styles.pageInfo}>
                        Página <strong>{pagination.currentPage}</strong> de {pagination.totalPages}
                    </span>

                    <button
                        onClick={pagination.onNext}
                        disabled={pagination.currentPage === pagination.totalPages || pagination.totalPages === 0}
                        className={styles.pageButton}
                    >
                        Siguiente
                    </button>
                </div>
            )}
        </div>
    );
};

export default DataTable;
